export default __webpack_public_path__ + "static/media/723x330.5b647ede.png";